import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Models
import mListParam from 'models/listParam';
// Custom
import TablePaginationNavigation from './TablePaginationNavigation';

const TablePagination = ({
  withActions, currentPage, pageSize, totalPages, totalEntries, onChange,
}) => {
  const firstItem = ((currentPage - 1) * pageSize) + 1;
  const lastItem = Math.min(currentPage * pageSize, totalEntries);

  return (
    withActions ? (
      <div className="table-pagination d-flex flex-wrap align-items-center">
        <div className="d-flex align-items-center my-2" style={{ flex: '0 0 auto' }}>
          <div className="mr-2">
            <LocalizedMessage id="info.rowsPerPage" />
          </div>
          <Select
            value={pageSize}
            items={
              _map(mListParam.paginationSizesList, (size) => ({
                key: _toString(size.value),
                value: size.value,
                label: _toString(size.value),
              }))
            }
            onChange={(value) => onChange({ page: currentPage, pageSize: value })}
            fullWidth={false}
            disableUnderline
            margin="none"
          />
          <div className="ml-4">
            <LocalizedMessage
              id="info.listItems"
              values={{ firstItem, lastItem, totalEntries }}
            />
          </div>
        </div>
        <div className="my-2 d-flex flex-wrap align-items-center justify-content-end" style={{ flex: '1 1 auto' }}>
          {totalPages > 10 && (
            <div className="d-flex align-items-center mr-4">
              <div className="mr-2">
                <LocalizedMessage id="info.page" />
              </div>
              <Select
                value={currentPage}
                items={
                  _map(Array.from(Array(totalPages), (_, i) => i + 1), (page) => ({
                    key: _toString(page),
                    value: page,
                    label: _toString(page),
                  }))
                }
                onChange={(value) => onChange({ page: value, pageSize })}
                fullWidth={false}
                disableUnderline
                margin="none"
              />
            </div>
          )}
          <TablePaginationNavigation
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={(value) => onChange({ page: value, pageSize })}
          />
        </div>
      </div>
    ) : (
      <div className="text-left d-flex align-items-center">
        <LocalizedMessage
          id="info.listItemsNoFirstLast"
          values={{ totalEntries }}
        />
      </div>
    )
  );
};

TablePagination.propTypes = {
  withActions: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalEntries: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TablePagination;



// WEBPACK FOOTER //
// ./components/core/table/TablePagination.js